module.exports = __webpack_public_path__ + "static/media/logo-space2.a0ec50f4.svg";